import { Col, Dropzone, Row, UploadPreview } from 'components/ui';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Tiles/boxes that preview user-uploaded photos and videos
const UploadPreviewBox = styled.div`
	/* min-width: 880px; */
	min-height: 100px;
	display: flex;
	flex-wrap: wrap;
`;

const BilderVideosForm = ({
	uploadVaxFile,
	files,
	removeFile,
	changeFileOrder,
	validation,
}) => {
	const onDrop = (acceptedFiles) => {
		for (let i = 0; i < acceptedFiles.length; i++) {
			const file = acceptedFiles[i];
			const formData = new FormData();
			formData.append('vaxFile', file);
			uploadVaxFile(formData, file.name);
		}
	};
	return (
		<>
			<Row className='justify-content-md-center'>
				<Col xs lg='12'>
					<Dropzone onDrop={onDrop} hasFiles={files?.length > 0} />
				</Col>
			</Row>
			<Row>
				<Col>
					<UploadPreviewBox>
						{files &&
							files.length > 0 &&
							orderBy(files, 'lexical_order').map((file, index) => {
								if (Object.hasOwn(file, 'file')) {
									file = { ...file, ...file.file };
								}
								return (
									<UploadPreview
										key={index}
										index={index}
										files={orderBy(files, 'lexical_order')}
										{...file}
										removeFile={removeFile}
										changeFileOrder={changeFileOrder}
										validation={validation[index]}
									/>
								);
							})}
					</UploadPreviewBox>
				</Col>
			</Row>
		</>
	);
};

BilderVideosForm.propTypes = {
	uploadVaxFile: PropTypes.func,
	removeFile: PropTypes.func,
	files: PropTypes.arrayOf(PropTypes.object),
	changeFileOrder: PropTypes.func,
};

export { BilderVideosForm };
